<template>
    <div class="relative isolate overflow-hidden">
        <!-- <svg class="absolute inset-0 -z-10 h-full w-full stroke-[var(--light-gray)] [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]" aria-hidden="true">
      <defs>
        <pattern id="0787a7c5-978c-4f66-83c7-11c213f99cb7" width="200" height="200" x="50%" y="-1" patternUnits="userSpaceOnUse">
          <path d="M.5 200V.5H200" fill="none" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" stroke-width="0" fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)" />
    </svg> -->
        <div class="snap-center mx-auto mt-12 sm:py-4 mb-12 px-3 sm:px-28 pb-24 pt-10 ">
            <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-3xl lg:flex-shrink-0 lg:pt-8">
                <!-- <img class="h-11" src="https://tailwindui.com/img/logos/mark.svg?color=indigo&amp;shade=600" alt="Your Company" />
        <div class="mt-24 sm:mt-32 lg:mt-16">
          <a href="#" class="inline-flex space-x-6">
            <span class="rounded-full bg-indigo-600/10 px-3 py-1 text-sm font-semibold leading-6 text-[var(--primary-blue)] ring-1 ring-inset ring-indigo-600/10">What's new</span>
            <span class="inline-flex items-center space-x-2 text-sm font-medium leading-6 text-[var(--medium-gray)]">
              <span>Just shipped v1.0</span>
              <ChevronRightIcon class="h-5 w-5 text-[var(--medium-gray)]" aria-hidden="true" />
            </span>
          </a>
        </div> -->
                <div class="body-subhero mt-10 tracking-tight" :class="{ 'w-screen': title.length > 20 }">
                    <div class="text-title gap-2 sm:gap-4 flex flex-wrap" style="line-height: 1.2">
                        <span v-for="(title, index) of title_array"
                            :class="{ colour: colour_indexes.includes(String(index)) }" class="whitespace-nowrap">
                            {{ title }}
                        </span>
                    </div>
                </div>

                <div class="mt-6 text-subtitle flex flex-col">
                    <div class="mb-4">
                        {{ subtitle }}
                    </div>
                    <div>
                        <span v-for="(part, index) in formattedSubtitleParts" :key="index">
                            <span v-if="part.isBold" class="text-bold">{{ part.text }}</span>
                            <span v-else>{{ part.text }}</span>
                        </span>
                    </div>
                </div>
                
                <slot></slot>

                <div class="mt-10 flex items-center gap-x-6">
                    <a v-for="(btn, index) of buttons" :href="btn.link" @click="click(btn.posthog_click_event)"
                        :class="{ 'btn-primary': btn.title && index === 0, 'btn-secondary bg-[var(--white)]': index !== 0 || !btn.title, 'rounded-full p-4': !btn.title }"
                        class="mb-2 w-full sm:w-auto sm:mb-0 btn text-center sm:text-left">
                        <span v-if="btn.title">{{ btn.title }}</span>
                        <Icon v-if="btn.icon" :name="btn.icon" :class="!btn.title ? 'text-3xl' : ''" />
                    </a>
                </div>
            </div>
            <div
                class="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
                <div class="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
                    <!-- <div class="-m-2 rounded-xl bg-[var(--dark-gray)]/5 p-2 ring-1 ring-inset ring-[var(--dark-gray)]/10 lg:-m-4 lg:rounded-2xl lg:p-4"> -->
                    <div class="jutify-right" :class="!image_96 && !image_128 ? 'sm:w-1/5 mt-8' : 'sm:w-2/5'">
                        <!-- <img :src="image_url" alt="App screenshot" class="w-[76rem] rounded-md shadow-2xl ring-1 ring-[var(--dark-gray)]/10" /> -->
                        <img v-if="image_url" :src="image_url"
                            class="object-contain float-right rounded-lg bg-[var(--white)] px-4 py-1 hidden lg:inline-block"
                            :class="image_96 ? 'w-96' : image_128 ? 'w-128' : 'w-32 h-32'" :alt="title" />

                        <slot name="sidebar" v-if="sidebar"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { capture } from '~/services/analytics';
import { type PropType } from 'vue';
import { isDev } from '~/services/common';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        image_url: String,
        image_96: Boolean,
        image_128: Boolean,
        colourIndex: String,
        subtitle: String,
        subsubtitle: String,
        subsubtitle_bold_text: {
            type: String,
            default: '',
        },
        buttons: Array as PropType<{ link: string; title?: string; icon?: string; posthog_click_event?: string }[]>,
        bottom_image_url: String,
        sidebar: Boolean,
        bg: Boolean,
    },
    data() {
        return {
            title_array: this.title.split(' '),
            colour_indexes: this.colourIndex?.split(',') || [],
        };
    },
    computed: {
        formattedSubtitleParts() {
            if (this.subsubtitle_bold_text === '') {
                return [{ text: this.subsubtitle, isBold: false }];
            }
            const parts = this.subsubtitle!.split(this.subsubtitle_bold_text);
            const formattedParts: any = [];

            parts.forEach((part, index) => {
                formattedParts.push({ text: part, isBold: false });
                if (index < parts.length - 1) {
                    formattedParts.push({ text: this.subsubtitle_bold_text, isBold: true });
                }
            });

            return formattedParts;
        }
    },
    methods: {
        click(posthog_click_event?: string) {
            if (isDev()) {
                return;
            }

            if (posthog_click_event) {
                capture(posthog_click_event);
            }
        },
    },
};
</script>